import { Injectable } from "@angular/core";
import * as lodash from "lodash";
import { BehaviorSubject, Subject } from "rxjs";
import { filter, map } from "rxjs/operators";
import { IConfigurationHolder } from "../models/auto-generated";

@Injectable({
  providedIn: "root"
})
export class SettingsStore {
  private originalSettings: IConfigurationHolder;

  private isReadOnly = new BehaviorSubject<boolean>(undefined);
  readonly isReadOnly$ = this.isReadOnly.asObservable();

  private validity: Map<string, boolean> = new Map();
  private isValid = new BehaviorSubject<boolean>(undefined);
  readonly isValid$ = this.isValid.asObservable();

  private settingsReset = new Subject<void>();
  readonly settingsReset$ = this.settingsReset.asObservable();

  private settings = new BehaviorSubject<IConfigurationHolder>(undefined);
  readonly settings$ = this.settings.asObservable();

  isDirty$ = this.settings$.pipe(filter((s) => !!s)).pipe(map((current) => !this.originalSettings || JSON.stringify(this.originalSettings) !== JSON.stringify(current)));

  hasGroupStorageChanged$ = this.settings$.pipe(filter((s) => !!s)).pipe(map((current) => this.originalSettings && this.originalSettings.groupStorage !== current.groupStorage));

  initializeSettings(source: IConfigurationHolder) {
    if (source.crmHeartbeatInterval <= 0) {
      source.crmHeartbeatInterval = 20;
    }
    this.originalSettings = lodash.cloneDeep(source);
    this.settings.next(source);
    this.isValid.next(true);
    this.validity.clear();
  }

  undoChanges() {
    this.settings.next(lodash.cloneDeep(this.originalSettings));
    this.settingsReset.next();
    this.isValid.next(true);
    this.validity.clear();
  }

  updateSettings(settings: IConfigurationHolder) {
    this.settings.next(settings);
  }

  updateValidity(name: string, valid: boolean) {
    this.validity.set(name, valid);
    this.isValid.next(Array.from(this.validity.values(), (v) => v).every((v) => v));
  }

  setIsReadOnly(readonly: boolean): void {
    this.isReadOnly.next(readonly);
  }
}
